var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "config"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('div', {
    staticClass: "form-group row"
  })])]), _vm._v(" "), (_vm.searchFlag) ? _c('b-tabs', [(_vm.warehouse != "undefined" && _vm.warehouse != '') ? _c('b-tab', {
    attrs: {
      "title": _vm.$t('config.outbound'),
      "card": "",
      "title-link-class": _vm.linkClass(0)
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row col-lg-12"
  }, [_c('b-card', {
    staticClass: "col-lg-12",
    staticStyle: {
      "line-height": "1.7"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.pickingType')) + " : "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickingtype),
      expression: "pickingtype"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "cluster",
      "name": "pickingtype",
      "value": "cluster"
    },
    domProps: {
      "checked": _vm._q(_vm.pickingtype, "cluster")
    },
    on: {
      "click": _vm.updatevalue,
      "__c": function($event) {
        _vm.pickingtype = "cluster"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "cluster"
    }
  }, [_vm._v(_vm._s(_vm.$t('config.cluster')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickingtype),
      expression: "pickingtype"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "batch",
      "name": "pickingtype",
      "value": "batch"
    },
    domProps: {
      "checked": _vm._q(_vm.pickingtype, "batch")
    },
    on: {
      "click": _vm.updatevalue,
      "__c": function($event) {
        _vm.pickingtype = "batch"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "batch"
    }
  }, [_vm._v(_vm._s(_vm.$t('config.batch')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pickingtype')),
      expression: "errors.has('pickingtype')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('config.selectOption')) + "\n                    ")])]), _vm._v(" "), (_vm.pickingtype == '') ? _c('span', {
    staticClass: "text-danger",
    model: {
      value: (_vm.showpickingtypeerror),
      callback: function($$v) {
        _vm.showpickingtypeerror = $$v
      },
      expression: "showpickingtypeerror"
    }
  }, [_vm._v(_vm._s(this.showpickingtypeerror) + "\n                  ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [(_vm.pickingtype == 'batch') ? _c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.batch')) + " " + _vm._s(_vm.$t('config.Size')) + " : ")])]) : _vm._e(), (_vm.pickingtype == 'batch') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" "), (_vm.pickingtype == 'cluster') ? _c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.cluster')) + " " + _vm._s(_vm.$t('config.Size')) + " : ")])]) : _vm._e(), (_vm.pickingtype == 'cluster') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickingsize),
      expression: "pickingsize"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('pickingsize')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.sizePlaceHolder'),
      "name": "pickingsize",
      "id": "pickingsize"
    },
    domProps: {
      "value": (_vm.pickingsize)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pickingsize = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pickingsize')),
      expression: "errors.has('pickingsize')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('config.clustersizeErr')) + "\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.allowdefaultSize')) + " : "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.flag),
      expression: "flag"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "enabledefaultsize",
      "name": "flag",
      "value": "yes"
    },
    domProps: {
      "checked": _vm._q(_vm.flag, "yes")
    },
    on: {
      "click": _vm.updateCluster,
      "__c": function($event) {
        _vm.flag = "yes"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enabledefaultsize"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.yes')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.flag),
      expression: "flag"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "disabledefaultsize",
      "value": "no",
      "name": "flag"
    },
    domProps: {
      "checked": _vm._q(_vm.flag, "no")
    },
    on: {
      "click": _vm.updateCluster,
      "__c": function($event) {
        _vm.flag = "no"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "disabledefaultsize"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.no')))]), _vm._v(" "), (_vm.flag == '') ? _c('span', {
    staticClass: "text-danger",
    model: {
      value: (_vm.showflagerror),
      callback: function($$v) {
        _vm.showflagerror = $$v
      },
      expression: "showflagerror"
    }
  }, [_vm._v(_vm._s(this.showflagerror) + "\n                    ")]) : _vm._e()])]), _vm._v(" "), (_vm.showBatch == true) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.enableAutobatch')) + " : "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.autocreate),
      expression: "autocreate"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "enableautobatch",
      "name": "autocreate",
      "value": "yes"
    },
    domProps: {
      "checked": _vm._q(_vm.autocreate, "yes")
    },
    on: {
      "__c": function($event) {
        _vm.autocreate = "yes"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enableautobatch"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.yes')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.autocreate),
      expression: "autocreate"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "disableautobatch",
      "value": "no",
      "name": "autocreate"
    },
    domProps: {
      "checked": _vm._q(_vm.autocreate, "no")
    },
    on: {
      "__c": function($event) {
        _vm.autocreate = "no"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "disableautobatch"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.no')))]), _vm._v(" "), (_vm.autocreate == '') ? _c('span', {
    staticClass: "text-danger",
    model: {
      value: (_vm.showautocreateerror),
      callback: function($$v) {
        _vm.showautocreateerror = $$v
      },
      expression: "showautocreateerror"
    }
  }, [_vm._v(_vm._s(this.showautocreateerror) + "\n                    ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.showBatch == true) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.maxSize')) + "  : ")])]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.maximumvalue),
      expression: "maximumvalue"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('maximumvalue')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('config.maxSize'),
      "name": "maximumvalue",
      "id": "maximumvalue"
    },
    domProps: {
      "value": (_vm.maximumvalue)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "keyup": _vm.checkValidation,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.maximumvalue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('maximumvalue')),
      expression: "errors.has('maximumvalue')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('config.maxSize')) + "\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    model: {
      value: (_vm.showmaximumvalueerror),
      callback: function($$v) {
        _vm.showmaximumvalueerror = $$v
      },
      expression: "showmaximumvalueerror"
    }
  }, [_vm._v(_vm._s(this.showmaximumvalueerror) + "\n                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.showBatch == true) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.minsize')) + ": ")])]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.defaultsize),
      expression: "defaultsize"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('defaultsize')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('config.minSizePlaceholder'),
      "name": "defaultsize",
      "id": "defaultsize"
    },
    domProps: {
      "value": (_vm.defaultsize)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "keyup": _vm.checkValidation,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.defaultsize = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('defaultsize')),
      expression: "errors.has('defaultsize')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('config.minSizeErr')) + "\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    model: {
      value: (_vm.showdefaultsizeerror),
      callback: function($$v) {
        _vm.showdefaultsizeerror = $$v
      },
      expression: "showdefaultsizeerror"
    }
  }, [_vm._v(_vm._s(this.showdefaultsizeerror) + "\n                    ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.showDefault == true) ? _c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.defaultSize')) + " : ")])]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]) : _vm._e(), _vm._v(" "), (_vm.showDefault == true) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.maxval),
      expression: "maxval"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('maxval')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('config.DefauleSizePlaceholder'),
      "name": "maxval",
      "id": "maxval"
    },
    domProps: {
      "value": (_vm.maxval)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "keyup": _vm.checkValidation,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.maxval = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('maxval')),
      expression: "errors.has('maxval')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('config.defaultSizeErr')) + "\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    model: {
      value: (_vm.showdefaultsizeerror),
      callback: function($$v) {
        _vm.showdefaultsizeerror = $$v
      },
      expression: "showdefaultsizeerror"
    }
  }, [_vm._v(_vm._s(this.showdefaultsizeerror) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.showDefault == false) ? _c('div', {
    staticClass: "col-lg-3"
  }) : _vm._e(), _vm._v(" "), (_vm.showDefault == false) ? _c('div', {
    staticClass: "col-lg-6"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-left": "45px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading,
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.checkValidation();
        _vm.saveconfig()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.saveBtn')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset",
      "size": "sm"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.$t('common.cancelBtn')))])])])])], 1)], 1), _vm._v(" "), _c('div', [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row col-lg-12"
  }, [_c('b-card', {
    staticClass: "col-lg-12",
    staticStyle: {
      "line-height": "1.7"
    }
  }, [_c('h3', {
    staticStyle: {
      "font-weight": "595"
    }
  }, [_vm._v(_vm._s(_vm.$t('config.specialInstructions')))]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center mb-4"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('config.specialInstruction')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('textarea', {
    staticClass: "form-control",
    staticStyle: {
      "width": "100%",
      "height": "50px"
    },
    attrs: {
      "autocomplete": "nope"
    },
    domProps: {
      "value": _vm.isEditing ? _vm.instructionNameEditTextarea : _vm.instructionNameAddTextarea
    },
    on: {
      "input": _vm.extractInput,
      "change": _vm.onChangeHandler
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-between"
  }, [(_vm.specialInstructionValidation == true) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('config.specialInstructionValidation')))]) : _vm._e(), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "600",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.$t('config.specialInstructionLimit')))])])], 1), _vm._v(" "), (_vm.isEditing == false) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('orders.salesChannel')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchchannel),
      expression: "searchchannel"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "searchchannel"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchchannel = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.onSalesChannelChange]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.salesChannelPlaceHolder')))]), _vm._v(" "), _vm._l((_vm.channellist), function(channel) {
    return _c('option', {
      domProps: {
        "value": channel.saleschannel
      }
    }, [_vm._v("\n                          " + _vm._s(channel.saleschannel) + "\n                        ")])
  })], 2)]), _vm._v(" "), (_vm.salesChannelValidation == true) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('config.salesChannelValidation')))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isEditing == true) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('orders.salesChannel')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "shipidflt",
      "readonly": ""
    },
    model: {
      value: (_vm.editingSalesChannel),
      callback: function($$v) {
        _vm.editingSalesChannel = $$v
      },
      expression: "editingSalesChannel"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 mt-4"
  }, [(_vm.isEditing == true) ? _c('button', {
    staticClass: "btn btn-success btn-lg d-flex align-items-center",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.addOrEditSpecialInstruction()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit fa-lg mr-2"
  }), _vm._v(" " + _vm._s(_vm.$t('config.edit')))]) : _vm._e(), _vm._v(" "), (_vm.isEditing == false) ? _c('button', {
    staticClass: "btn btn-success btn-lg d-flex align-items-center",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.addOrEditSpecialInstruction()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-lg mr-2"
  }), _vm._v(" " + _vm._s(_vm.$t('config.add')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('config.salesChannel')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('config.instructions')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('config.actions')))])])]), _vm._v(" "), _c('tbody', [(_vm.specialInstructionCount == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v(_vm._s(_vm.$t('config.specialInstructionNotFound')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.specialInstructionList), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(data.channelname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(data.instructionname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_c('i', {
      staticClass: "fa fa-times-rectangle-o fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "color": "red",
        "font-size": "15px"
      },
      attrs: {
        "title": "Cancel Instruction"
      },
      on: {
        "click": function($event) {
          _vm.confirmationDeleteSpecialInstruction(data)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-pencil fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "color": "red"
      },
      attrs: {
        "title": "Edit Instruction"
      },
      on: {
        "click": function($event) {
          _vm.editSpecialInstruction(data)
        }
      }
    })])])
  })], 2)]), _vm._v(" "), _c('br')])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.closeSpecialInstructionModal = false
      }
    },
    model: {
      value: (_vm.closeSpecialInstructionModal),
      callback: function($$v) {
        _vm.closeSpecialInstructionModal = $$v
      },
      expression: "closeSpecialInstructionModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pincodemapping.confirmation')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusSpecialInstructionModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('config.deleteConfirmationMessage')))]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": [function($event) {
        _vm.deleteSpecialInstruction()
      }, function($event) {
        _vm.closeStatusSpecialInstructionModal = false
      }]
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('config.yesButton')))]), _vm._v(" \n                    "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeStatusSpecialInstructionModal
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.$t('config.noButton')))])])])])])])])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.warehouse != "undefined" && _vm.warehouse != '') ? _c('b-tab', {
    attrs: {
      "title": _vm.$t('config.picking')
    }
  }, [_c('form', {
    staticStyle: {
      "padding-bottom": "1%"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row col-lg-12"
  }, [_c('b-card', {
    staticClass: "col-lg-12",
    staticStyle: {
      "line-height": "1.7"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.assignmentType')) + " :"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assigntype),
      expression: "assigntype"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "manual",
      "name": "assigntype",
      "value": "manual"
    },
    domProps: {
      "checked": _vm._q(_vm.assigntype, "manual")
    },
    on: {
      "__c": function($event) {
        _vm.assigntype = "manual"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "manual"
    }
  }, [_vm._v(_vm._s(_vm.$t('config.manual')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assigntype),
      expression: "assigntype"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "automatic",
      "name": "assigntype",
      "value": "automatic"
    },
    domProps: {
      "checked": _vm._q(_vm.assigntype, "automatic")
    },
    on: {
      "__c": function($event) {
        _vm.assigntype = "automatic"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "automatic"
    }
  }, [_vm._v(_vm._s(_vm.$t('config.automatic')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('assigntype')),
      expression: "errors.has('assigntype')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('config.AssignmentTypError')) + "\n                    ")])]), _vm._v(" "), (_vm.assigntype == '') ? _c('span', {
    staticClass: "text-danger",
    model: {
      value: (_vm.showassigntypeerror),
      callback: function($$v) {
        _vm.showassigntypeerror = $$v
      },
      expression: "showassigntypeerror"
    }
  }, [_vm._v(_vm._s(this.showassigntypeerror) + "\n                  ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.allowBulkPick')) + " :"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickflag),
      expression: "pickflag"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "enablebulk",
      "name": "pickflag",
      "value": "yes"
    },
    domProps: {
      "checked": _vm._q(_vm.pickflag, "yes")
    },
    on: {
      "__c": function($event) {
        _vm.pickflag = "yes"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enablebulk"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.yes')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickflag),
      expression: "pickflag"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "disablebulk",
      "value": "no",
      "name": "pickflag"
    },
    domProps: {
      "checked": _vm._q(_vm.pickflag, "no")
    },
    on: {
      "__c": function($event) {
        _vm.pickflag = "no"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "disablebulk"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.no')))]), _vm._v(" "), (_vm.pickflag == '') ? _c('span', {
    staticClass: "text-danger",
    model: {
      value: (_vm.showpickflagerror),
      callback: function($$v) {
        _vm.showpickflagerror = $$v
      },
      expression: "showpickflagerror"
    }
  }, [_vm._v(_vm._s(this.showpickflagerror) + "\n                    ")]) : _vm._e()])]), _vm._v(" "), (_vm.pickflag == 'yes') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.minBulkPick')) + ": ")])]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickqtysize),
      expression: "pickqtysize"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('pickqtysize')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('config.minBulkPickPlaceHolder'),
      "name": "pickqtysize",
      "id": "pickqtysize"
    },
    domProps: {
      "value": (_vm.pickqtysize)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber1($event)
      },
      "keyup": _vm.checkValidationForPickAssign,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pickqtysize = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pickqtysize')),
      expression: "errors.has('pickqtysize')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('config.minBulkPickError')) + "\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    model: {
      value: (_vm.showpickqtysizeerror),
      callback: function($$v) {
        _vm.showpickqtysizeerror = $$v
      },
      expression: "showpickqtysizeerror"
    }
  }, [_vm._v(_vm._s(this.showpickqtysizeerror) + "\n                    ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-left": "135px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading,
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.savePickerAssignmentType()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.saveBtn')))])])])], 1)], 1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row col-lg-12"
  }, [_c('b-card', {
    staticClass: "col-lg-12",
    staticStyle: {
      "line-height": "1.7"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.enableManualEntryEancode')) + " :"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.eancodeFlag),
      expression: "eancodeFlag"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "eanmanualyes",
      "name": "eancodeFlag",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.eancodeFlag, "1")
    },
    on: {
      "__c": function($event) {
        _vm.eancodeFlag = "1"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "yes"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.yes')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.eancodeFlag),
      expression: "eancodeFlag"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "eanmanualno",
      "name": "eancodeFlag",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.eancodeFlag, "0")
    },
    on: {
      "__c": function($event) {
        _vm.eancodeFlag = "0"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "no"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.no')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('eancodeFlag')),
      expression: "errors.has('eancodeFlag')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('config.AssignmentTypError')) + "\n                    ")])]), _vm._v(" "), (_vm.eancodeFlag == '') ? _c('span', {
    staticClass: "text-danger",
    model: {
      value: (_vm.showEancodeError),
      callback: function($$v) {
        _vm.showEancodeError = $$v
      },
      expression: "showEancodeError"
    }
  }, [_vm._v(_vm._s(this.showEancodeError) + "\n                  ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-left": "135px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading,
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.saveEancodeFlag()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.saveBtn')))])])])], 1)], 1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row col-lg-12"
  }, [_c('b-card', {
    staticClass: "col-lg-12",
    staticStyle: {
      "line-height": "1.7"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.enableAutoFillBoxid')) + " :"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.autofillboxFlag),
      expression: "autofillboxFlag"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "eaautofilyes",
      "name": "autofillboxFlag",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.autofillboxFlag, "1")
    },
    on: {
      "__c": function($event) {
        _vm.autofillboxFlag = "1"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "yes"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.yes')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.autofillboxFlag),
      expression: "autofillboxFlag"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "eanautofilno",
      "name": "autofillboxFlag",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.autofillboxFlag, "0")
    },
    on: {
      "__c": function($event) {
        _vm.autofillboxFlag = "0"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "no"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.no')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('autofillFlag')),
      expression: "errors.has('autofillFlag')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('config.AssignmentTypError')) + "\n                    ")])]), _vm._v(" "), (_vm.autofillFlag == '') ? _c('span', {
    staticClass: "text-danger",
    model: {
      value: (_vm.showAutofillboxError),
      callback: function($$v) {
        _vm.showAutofillboxError = $$v
      },
      expression: "showAutofillboxError"
    }
  }, [_vm._v(_vm._s(this.showAutofillboxError) + "\n                  ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-left": "135px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading,
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.saveAutofillboxFlag()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.saveBtn')))])])])], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.warehouse != "undefined" && _vm.warehouse != '') ? _c('b-tab', {
    attrs: {
      "title": _vm.$t('config.returns')
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row col-lg-12"
  }, [_c('b-card', {
    staticClass: "col-lg-12",
    staticStyle: {
      "line-height": "1.7"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.RTOSRInscan')) + " :"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rtoInscan),
      expression: "rtoInscan"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "enableInscan",
      "name": "rtoInscan",
      "value": "yes"
    },
    domProps: {
      "checked": _vm._q(_vm.rtoInscan, "yes")
    },
    on: {
      "__c": function($event) {
        _vm.rtoInscan = "yes"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enableInscan"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.yes')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rtoInscan),
      expression: "rtoInscan"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "disableInscan",
      "name": "rtoInscan",
      "value": "no"
    },
    domProps: {
      "checked": _vm._q(_vm.rtoInscan, "no")
    },
    on: {
      "__c": function($event) {
        _vm.rtoInscan = "no"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "disableInscan"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.no')))])]), _vm._v(" "), (_vm.rtoInscanError) ? _c('div', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.$t('config.selectOption')) + "\n                  ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.enableAutoMatch')) + " :"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.autoMatch),
      expression: "autoMatch"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "enableAutoMatch",
      "name": "autoMatch",
      "value": "yes"
    },
    domProps: {
      "checked": _vm._q(_vm.autoMatch, "yes")
    },
    on: {
      "__c": function($event) {
        _vm.autoMatch = "yes"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enableAutoMatch"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.yes')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.autoMatch),
      expression: "autoMatch"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "disableAutoMatch",
      "name": "autoMatch",
      "value": "no"
    },
    domProps: {
      "checked": _vm._q(_vm.autoMatch, "no")
    },
    on: {
      "__c": function($event) {
        _vm.autoMatch = "no"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "disableAutoMatch"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.no')))])]), _vm._v(" "), (_vm.autoMatchError) ? _c('div', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.$t('config.selectOption')) + "\n                  ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "margin-left": "135px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading,
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.saveInscanConfig()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.saveBtn')))])])])])])])], 1)], 1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row col-lg-12"
  }, [_c('b-card', {
    staticClass: "col-lg-12",
    staticStyle: {
      "line-height": "1.7"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.enableExpiryThreshold')) + " :"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.expiryThreshold),
      expression: "expiryThreshold"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "enableExpiryThreshold",
      "name": "expiryThreshold",
      "value": "yes"
    },
    domProps: {
      "checked": _vm._q(_vm.expiryThreshold, "yes")
    },
    on: {
      "__c": function($event) {
        _vm.expiryThreshold = "yes"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enableExpiryThreshold"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.yes')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.expiryThreshold),
      expression: "expiryThreshold"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "disableExpiryThreshold",
      "name": "expiryThreshold",
      "value": "no"
    },
    domProps: {
      "checked": _vm._q(_vm.expiryThreshold, "no")
    },
    on: {
      "__c": function($event) {
        _vm.expiryThreshold = "no"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "disableExpiryThreshold"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.no')))])]), _vm._v(" "), (_vm.expiryThresholdError) ? _c('div', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.$t('config.selectOption')) + "\n                  ")]) : _vm._e()]), _vm._v(" "), (_vm.expiryThreshold == 'yes') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('label', [_c('strong', [_vm._v(" " + _vm._s(_vm.$t('config.thresholdValue')) + ": ")])]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.returnThresholdDays),
      expression: "returnThresholdDays"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('returnThresholdDays')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('config.threshHoldPlaceHolder'),
      "name": "returnThresholdDays",
      "id": "returnThresholdDays"
    },
    domProps: {
      "value": (_vm.returnThresholdDays)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber1($event)
      },
      "keyup": _vm.checkValidationForPickAssign,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.returnThresholdDays = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('returnThresholdDays')),
      expression: "errors.has('returnThresholdDays')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('config.threshholdError')) + "\n                    ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "margin-left": "135px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading,
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.saveThresholdReturns()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.saveBtn')))])])])])])])], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.warehouse != "undefined" && _vm.warehouse != '') ? _c('b-tab', {
    attrs: {
      "title": _vm.$t('config.audit')
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row col-lg-12"
  }, [_c('b-card', {
    staticClass: "col-lg-12",
    staticStyle: {
      "line-height": "1.7"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.sessionTime')) + ": "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-address-book'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sessiontime),
      expression: "sessiontime"
    }],
    staticStyle: {
      "width": "136px"
    },
    attrs: {
      "type": "number",
      "id": "sessiontime",
      "min": "0",
      "required": "true",
      "name": "sessiontime"
    },
    domProps: {
      "value": (_vm.sessiontime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sessiontime = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), (_vm.audit) ? _c('div', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('config.SessionTimeSize')) + " ")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.auditPendingTime')) + ": "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-history'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.audittime),
      expression: "audittime"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('audittime')
    },
    staticStyle: {
      "width": "136px"
    },
    attrs: {
      "type": "number",
      "id": "audittime",
      "min": "0",
      "name": "audittime"
    },
    domProps: {
      "value": (_vm.audittime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.audittime = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.errorAuditHour) ? _c('div', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.$t('config.PendingTime')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.allowExcessQuantity')) + " :"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.excessqty),
      expression: "excessqty"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "enableexcessqty",
      "name": "excessqty",
      "value": "yes"
    },
    domProps: {
      "checked": _vm._q(_vm.excessqty, "yes")
    },
    on: {
      "__c": function($event) {
        _vm.excessqty = "yes"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enableexcessqty"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.yes')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.excessqty),
      expression: "excessqty"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "disableexcessqty",
      "name": "excessqty",
      "value": "no"
    },
    domProps: {
      "checked": _vm._q(_vm.excessqty, "no")
    },
    on: {
      "__c": function($event) {
        _vm.excessqty = "no"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "disableexcessqty"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.no')))])]), _vm._v(" "), (_vm.excessqtyError) ? _c('div', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.$t('config.selectAnOption')) + "\n                  ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.allowExcessProductQuantity')) + " :"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.excessprodqty),
      expression: "excessprodqty"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "enableexcessprodqty",
      "name": "excessprodqty",
      "value": "yes"
    },
    domProps: {
      "checked": _vm._q(_vm.excessprodqty, "yes")
    },
    on: {
      "__c": function($event) {
        _vm.excessprodqty = "yes"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enableexcessprodqty"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.yes')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.excessprodqty),
      expression: "excessprodqty"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "disableexcessprodqty",
      "name": "excessprodqty",
      "value": "no"
    },
    domProps: {
      "checked": _vm._q(_vm.excessprodqty, "no")
    },
    on: {
      "__c": function($event) {
        _vm.excessprodqty = "no"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "disableexcessprodqty"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.no')))])]), _vm._v(" "), (_vm.excessprodqtyError) ? _c('div', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.$t('config.selectAnOption')) + "\n                  ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "disabled": _vm.isLoading,
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.saveconfigaudit()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.saveBtn')))])])])])])], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.warehouse != "undefined" && _vm.warehouse != '') ? _c('b-tab', {
    attrs: {
      "title": _vm.$t('config.grcCheckIN')
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row col-lg-12"
  }, [_c('b-card', {
    staticClass: "col-lg-12",
    staticStyle: {
      "line-height": "1.7"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.overreceipttolerance')) + ": "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-money'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Tolerancepercentage),
      expression: "Tolerancepercentage"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|decimal'),
      expression: "'required|decimal'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Tolerancepercentage')
    },
    attrs: {
      "type": "number",
      "step": "any",
      "placeholder": _vm.$t('config.toleranePlaceHolder'),
      "min": "0",
      "max": "100",
      "name": "Tolerancepercentage",
      "id": "Tolerancepercentage"
    },
    domProps: {
      "value": (_vm.Tolerancepercentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Tolerancepercentage = $event.target.value
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('i', {
    staticClass: "fa fa-percent",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_c('strong', [_vm._v(" " + _vm._s(_vm.$t('config.bypassreceipttolerance')) + ":"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user-o'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.roleid),
      expression: "roleid"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "roleid",
      "name": "roleid"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.roleid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('config.selectrole')))]), _vm._v(" "), _vm._l((_vm.RoleListData), function(client_obj) {
    return _c('option', {
      domProps: {
        "value": client_obj.roleid
      }
    }, [_vm._v(_vm._s(client_obj.rolename))])
  })], 2)]), _vm._v(" "), (_vm.roleid == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.ClientErr))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-left": "345px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "disabled": _vm.isLoading,
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.saveReceiptQtytolerances()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.saveBtn')))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.roleid == '') ? _c('span', {
    staticClass: "text-danger",
    model: {
      value: (_vm.roleiderror),
      callback: function($$v) {
        _vm.roleiderror = $$v
      },
      expression: "roleiderror"
    }
  }, [_vm._v(_vm._s(this.roleiderror) + "\n                  ")]) : _vm._e()])])], 1)], 1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row col-lg-12"
  }, [_c('b-card', {
    staticClass: "col-lg-12",
    staticStyle: {
      "line-height": "1.7"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.enableDRCheck')) + ":"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enabledrcheck),
      expression: "enabledrcheck"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "enabledrcheckyes",
      "name": "enabledrcheck",
      "value": "yes"
    },
    domProps: {
      "checked": _vm._q(_vm.enabledrcheck, "yes")
    },
    on: {
      "__c": function($event) {
        _vm.enabledrcheck = "yes"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enabledrcheckyes"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.yes')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enabledrcheck),
      expression: "enabledrcheck"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "enabledrcheckno",
      "name": "enabledrcheck",
      "value": "no"
    },
    domProps: {
      "checked": _vm._q(_vm.enabledrcheck, "no")
    },
    on: {
      "__c": function($event) {
        _vm.enabledrcheck = "no"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enabledrcheckno"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.no')))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-left": "345px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "disabled": _vm.isLoading,
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.saveDRCheckRackin()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.saveBtn')))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(this.enabledrcheckerror))])])])], 1)], 1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row col-lg-12"
  }, [_c('b-card', {
    staticClass: "col-lg-12",
    staticStyle: {
      "line-height": "1.7"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.enableDoubleRackCheck')) + ":"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enablemultirackcheck),
      expression: "enablemultirackcheck"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "enablemultirackcheckyes",
      "name": "enablemultirackcheck",
      "value": "yes"
    },
    domProps: {
      "checked": _vm._q(_vm.enablemultirackcheck, "yes")
    },
    on: {
      "__c": function($event) {
        _vm.enablemultirackcheck = "yes"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enablemultirackcheckyes"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.yes')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enablemultirackcheck),
      expression: "enablemultirackcheck"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "enablemultirackcheckno",
      "name": "enablemultirackcheck",
      "value": "no"
    },
    domProps: {
      "checked": _vm._q(_vm.enablemultirackcheck, "no")
    },
    on: {
      "__c": function($event) {
        _vm.enablemultirackcheck = "no"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enablemultirackcheckno"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.no')))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-left": "345px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "disabled": _vm.isLoading,
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.saveMultiRackValidationRackin()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.saveBtn')))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(this.enablemultirackcheckerror))])])])], 1)], 1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row col-lg-12"
  }, [_c('b-card', {
    staticClass: "col-lg-12",
    staticStyle: {
      "line-height": "1.7"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.enableSubinventorycheck')) + ":"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enablesubinvcheck),
      expression: "enablesubinvcheck"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "enablesubinvcheckyes",
      "name": "enablesubinvcheck",
      "value": "yes"
    },
    domProps: {
      "checked": _vm._q(_vm.enablesubinvcheck, "yes")
    },
    on: {
      "__c": function($event) {
        _vm.enablesubinvcheck = "yes"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enablesubinvcheckyes"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.yes')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enablesubinvcheck),
      expression: "enablesubinvcheck"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "enablesubinvcheckno",
      "name": "enablesubinvcheck",
      "value": "no"
    },
    domProps: {
      "checked": _vm._q(_vm.enablesubinvcheck, "no")
    },
    on: {
      "__c": function($event) {
        _vm.enablesubinvcheck = "no"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enablesubinvcheckno"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.no')))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-left": "345px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "disabled": _vm.isLoading,
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.saveSubinventorycheck()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.saveBtn')))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(this.enablesubinvcheckerror))])])])], 1)], 1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row col-lg-12"
  }, [_c('b-card', {
    staticClass: "col-lg-12",
    staticStyle: {
      "line-height": "1.7"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.enableAutoDrClose')) + ":"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enableautodrclose),
      expression: "enableautodrclose"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "enablautodrclosekyes",
      "name": "enableautodrclose",
      "value": "yes"
    },
    domProps: {
      "checked": _vm._q(_vm.enableautodrclose, "yes")
    },
    on: {
      "__c": function($event) {
        _vm.enableautodrclose = "yes"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enablautodrclosekyes"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.yes')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enableautodrclose),
      expression: "enableautodrclose"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "enablautodrclosekno",
      "name": "enableautodrclose",
      "value": "no"
    },
    domProps: {
      "checked": _vm._q(_vm.enableautodrclose, "no")
    },
    on: {
      "__c": function($event) {
        _vm.enableautodrclose = "no"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enablautodrclosekno"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.no')))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-left": "345px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "disabled": _vm.isLoading,
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.saveAutoDrclose()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.saveBtn')))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(this.enableautodrcloseerror))])])])], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.client != 'undefined') ? _c('b-tab', {
    attrs: {
      "title": _vm.$t('config.ecom')
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row col-lg-12"
  }, [_c('b-card', {
    staticClass: "col-lg-12",
    staticStyle: {
      "line-height": "1.7"
    }
  }, [_c('legend', [_vm._v(_vm._s(_vm.$t('config.ecomXb')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.ecomXB')) + ": ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ecommxb),
      expression: "ecommxb"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "enableEcommXB",
      "name": "ecommxb",
      "value": "yes"
    },
    domProps: {
      "checked": _vm._q(_vm.ecommxb, "yes")
    },
    on: {
      "click": _vm.saveconfigEcommXBOnOff,
      "__c": function($event) {
        _vm.ecommxb = "yes"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enableEcommXB"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.yes')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ecommxb),
      expression: "ecommxb"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "disableEcomm",
      "name": "ecommxb",
      "value": "no"
    },
    domProps: {
      "checked": _vm._q(_vm.ecommxb, "no")
    },
    on: {
      "click": _vm.saveconfigEcommXBOnOff,
      "__c": function($event) {
        _vm.ecommxb = "no"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "disableEcomm"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.no')))])]), _vm._v(" "), (_vm.ecommErrorxb) ? _c('div', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.$t('config.selectAnOption')) + "\n                  ")]) : _vm._e()]), _vm._v(" "), _c('legend', [_vm._v(_vm._s(_vm.$t('config.ecomShipment')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(" " + _vm._s(_vm.$t('config.ecom')) + ": ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ecomm),
      expression: "ecomm"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "enableEcommShipment",
      "name": "ecomm",
      "value": "yes"
    },
    domProps: {
      "checked": _vm._q(_vm.ecomm, "yes")
    },
    on: {
      "click": _vm.saveconfigEcommOnOff,
      "__c": function($event) {
        _vm.ecomm = "yes"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enableEcommShipment"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('config.on')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ecomm),
      expression: "ecomm"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "disableEcommShipment",
      "name": "ecomm",
      "value": "no"
    },
    domProps: {
      "checked": _vm._q(_vm.ecomm, "no")
    },
    on: {
      "click": _vm.saveconfigEcommOnOff,
      "__c": function($event) {
        _vm.ecomm = "no"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "disableEcommShipment"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('config.off')))])]), _vm._v(" "), (_vm.ecommError) ? _c('div', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.$t('config.selectAnOption')) + "\n                  ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-2"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('srqc.courierName')) + " : ")])]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user-o'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Cname),
      expression: "Cname"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Cname"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.Cname = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('config.courrierNamePlaceHolder')))]), _vm._v(" "), _vm._l((_vm.CourierCompList), function(couriercomp) {
    return _c('option', {
      domProps: {
        "value": couriercomp
      }
    }, [_vm._v(_vm._s(couriercomp))])
  })], 2)]), _vm._v(" "), (_vm.Cname == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.ClientErr))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user-o'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Otype),
      expression: "Otype"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Otype"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.Otype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('errorLogReport.errorTypePlaceHolder')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PPD"
    }
  }, [_vm._v(_vm._s(_vm.$t('config.prepaid')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "COD"
    }
  }, [_vm._v(_vm._s(_vm.$t('config.cod')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Both"
    }
  }, [_vm._v(_vm._s(_vm.$t('config.both')))])])]), _vm._v(" "), (_vm.Otype == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.OtypeErr))]) : _vm._e()], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-left": "340px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading,
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.checkValidationForEcomm();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.saveBtn')))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [(_vm.EcommList.length > 0) ? _c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.ecomAllowFor')) + " :-")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [(_vm.EcommList.length > 0) ? _c('table', {
    staticClass: "table-bordered",
    staticStyle: {
      "border-spacing": "0px !important",
      "font-size": "12px"
    },
    attrs: {
      "width": "80%",
      "border": "1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "width": "60%"
    }
  }, [_c('td', {
    staticClass: "text-center",
    staticStyle: {
      "background-color": "#ffff"
    }
  }, [_c('label', {
    staticStyle: {
      "text-align": "Center !important",
      "font-size": "12px"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('manifestReport.table.columns.courierName')))])])]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "background-color": "#ffff"
    }
  }, [_c('label', {
    staticStyle: {
      "text-align": "Center !important",
      "font-size": "12px"
    }
  }, [_c('strong', [_vm._v("\n                              " + _vm._s(_vm.$t('config.method')) + "\n                              ")])])]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "background-color": "#ffff"
    }
  }, [_c('label', {
    staticStyle: {
      "text-align": "Center !important",
      "font-size": "12px"
    }
  }, [_c('strong', [_vm._v("\n                              " + _vm._s(_vm.$t('stockTransfer.action')) + "\n                              ")])])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.EcommList), function(data) {
    return _c('tr', {
      attrs: {
        "width": "60%"
      }
    }, [_c('td', {
      staticClass: "text-center",
      staticStyle: {
        "background-color": "#ffff"
      }
    }, [_c('label', {
      staticStyle: {
        "text-align": "Center !important",
        "font-size": "12px"
      }
    }, [_c('strong', [_vm._v(_vm._s(data.shippingCompName))])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "background-color": "#ffff"
      }
    }, [_c('label', {
      staticStyle: {
        "text-align": "center !important",
        "font-size": "12px"
      }
    }, [_c('strong', [_vm._v("\n                                " + _vm._s(data.type) + "\n                              ")])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "background-color": "#ffff"
      },
      on: {
        "click": function($event) {
          _vm.openModal(data)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      staticStyle: {
        "font-size": "20px",
        "color": "red"
      }
    })])])
  }))]) : _vm._e()])])])], 1)], 1), _vm._v(" "), _c('b-modal', {
    staticClass: "reModal",
    attrs: {
      "size": "md",
      "title": "Alert Message"
    },
    model: {
      value: (_vm.removeData),
      callback: function($$v) {
        _vm.removeData = $$v
      },
      expression: "removeData"
    }
  }, [_c('b-card', [_c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: " col-md-10",
    staticStyle: {
      "padding": "0px 0px 20px 80px"
    }
  }, [_c('h6', {
    staticClass: "text-center"
  }, [_c('label', [_c('b', [_vm._v(_vm._s(_vm.$t('config.DeleteEcomFor')) + " " + _vm._s(_vm.removecompName))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.removeData = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-success float-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deleteRecord
    }
  }, [_vm._v(_vm._s(_vm.$t('common.confirm')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.cancelBtn')))])])])])])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.client != "undefined" && _vm.client != '') ? _c('b-tab', {
    attrs: {
      "title": _vm.$t('config.mrpExpiry')
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row col-lg-12"
  }, [_c('b-card', {
    staticClass: "col-lg-12",
    staticStyle: {
      "line-height": "1.7"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.mrpCheck')) + " :")])]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mrpchecknew),
      expression: "mrpchecknew"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "enablemrp",
      "name": "mrpchecknew",
      "value": "yes"
    },
    domProps: {
      "checked": _vm._q(_vm.mrpchecknew, "yes")
    },
    on: {
      "__c": function($event) {
        _vm.mrpchecknew = "yes"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enablemrp"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.yes')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mrpchecknew),
      expression: "mrpchecknew"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "disablemrp",
      "name": "mrpchecknew",
      "value": "no"
    },
    domProps: {
      "checked": _vm._q(_vm.mrpchecknew, "no")
    },
    on: {
      "__c": function($event) {
        _vm.mrpchecknew = "no"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "disablemrp"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.no')))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.expiryCheck')) + " :")])]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.expirycheck),
      expression: "expirycheck"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "enableexp",
      "name": "expirycheck",
      "value": "yes"
    },
    domProps: {
      "checked": _vm._q(_vm.expirycheck, "yes")
    },
    on: {
      "__c": function($event) {
        _vm.expirycheck = "yes"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enableexp"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.yes')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.expirycheck),
      expression: "expirycheck"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "disableexp",
      "name": "expirycheck",
      "value": "no"
    },
    domProps: {
      "checked": _vm._q(_vm.expirycheck, "no")
    },
    on: {
      "__c": function($event) {
        _vm.expirycheck = "no"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "disableexp"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.no')))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.countInDays')) + " :"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bookmark'></i>"
    }
  }, [(_vm.expirycheck != '') ? _c('b-form-input', {
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('config.countPlaceHolder'),
      "min": "1",
      "name": "expcount",
      "id": "expcount",
      "disabled": _vm.expirycheck === 'no' ? true : false
    },
    model: {
      value: (_vm.expcount),
      callback: function($$v) {
        _vm.expcount = $$v
      },
      expression: "expcount"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.expirycheck == '') ? _c('b-form-input', {
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('config.countPlaceHolder'),
      "min": "1",
      "name": "expcount",
      "id": "expcount",
      "disabled": ""
    },
    model: {
      value: (_vm.expcount),
      callback: function($$v) {
        _vm.expcount = $$v
      },
      expression: "expcount"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.expiryDayError))])], 1)]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.thresholdB2BOrderQty')) + ":")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cart-plus'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.b2bqty),
      expression: "b2bqty"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('b2bqty')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('config.thresholdB2BOrderPlaceHolder'),
      "name": "b2bqty",
      "id": "b2bqty"
    },
    domProps: {
      "value": (_vm.b2bqty)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber1($event)
      },
      "keyup": _vm.checkValidation,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.b2bqty = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.b2bqtyError))])], 1)]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.partialOrder')) + " :")])]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.partialorder),
      expression: "partialorder"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "enableorder",
      "name": "partialorder",
      "value": "yes"
    },
    domProps: {
      "checked": _vm._q(_vm.partialorder, "yes")
    },
    on: {
      "__c": function($event) {
        _vm.partialorder = "yes"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enableorder"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.yes')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.partialorder),
      expression: "partialorder"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "disableorder",
      "name": "partialorder",
      "value": "no"
    },
    domProps: {
      "checked": _vm._q(_vm.partialorder, "no")
    },
    on: {
      "__c": function($event) {
        _vm.partialorder = "no"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "disableorder"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.no')))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.enablePackingBox')) + "  : "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packingbox),
      expression: "packingbox"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "packingbox",
      "name": "packingbox",
      "value": "yes"
    },
    domProps: {
      "checked": _vm._q(_vm.packingbox, "yes")
    },
    on: {
      "__c": function($event) {
        _vm.packingbox = "yes"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enablepackingbox"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.yes')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packingbox),
      expression: "packingbox"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "packingbox",
      "value": "no",
      "name": "packingbox"
    },
    domProps: {
      "checked": _vm._q(_vm.packingbox, "no")
    },
    on: {
      "__c": function($event) {
        _vm.packingbox = "no"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "disablepackingbox"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.no')))]), _vm._v(" "), (_vm.packingbox == '') ? _c('span', {
    staticClass: "text-danger",
    model: {
      value: (_vm.showpackingboxerror),
      callback: function($$v) {
        _vm.showpackingboxerror = $$v
      },
      expression: "showpackingboxerror"
    }
  }, [_vm._v(_vm._s(this.showpackingboxerror) + "\n                    ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.enableactivemrp')) + "  :")])]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activemrp),
      expression: "activemrp"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "enableactivemrp",
      "name": "activemrp",
      "value": "yes"
    },
    domProps: {
      "checked": _vm._q(_vm.activemrp, "yes")
    },
    on: {
      "__c": function($event) {
        _vm.activemrp = "yes"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enableactivemrp"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.yes')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activemrp),
      expression: "activemrp"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "disablemrp",
      "name": "activemrp",
      "value": "no"
    },
    domProps: {
      "checked": _vm._q(_vm.activemrp, "no")
    },
    on: {
      "__c": function($event) {
        _vm.activemrp = "no"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "disableactivemrp"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.no')))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "margin-left": "135px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading,
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.lotMrpControl()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.saveBtn')))])])])])])])], 1)], 1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row col-lg-12"
  }, [_c('b-card', {
    staticClass: "col-lg-12",
    staticStyle: {
      "line-height": "1.7"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.splitbox')) + " :")])]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.splitbox),
      expression: "splitbox"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "enablesplitbox",
      "name": "splitbox",
      "value": "yes"
    },
    domProps: {
      "checked": _vm._q(_vm.splitbox, "yes")
    },
    on: {
      "__c": function($event) {
        _vm.splitbox = "yes"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enablesplitbox"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.yes')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.splitbox),
      expression: "splitbox"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "disablesplitbox",
      "name": "splitbox",
      "value": "no"
    },
    domProps: {
      "checked": _vm._q(_vm.splitbox, "no")
    },
    on: {
      "__c": function($event) {
        _vm.splitbox = "no"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "disablesplitbox"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.no')))]), _vm._v(" "), (_vm.splitbox == '') ? _c('span', {
    staticClass: "text-danger",
    model: {
      value: (_vm.splitboxerror),
      callback: function($$v) {
        _vm.splitboxerror = $$v
      },
      expression: "splitboxerror"
    }
  }, [_vm._v(_vm._s(this.splitboxerror) + "\n                    ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "margin-left": "135px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading,
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.saveSplitBox()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.saveBtn')))])])])])])])], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.client != "undefined" && _vm.client != '') ? _c('b-tab', {
    attrs: {
      "title": _vm.$t('config.invoice')
    }
  }, [_c('form', {
    attrs: {
      "enctype": "multipart/form-data"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row col-lg-12"
  }, [_c('b-card', {
    staticClass: "col-lg-12",
    staticStyle: {
      "line-height": "1.7"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('editedjson.enableUploadInvoice')) + ": "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.uploadinvoice),
      expression: "uploadinvoice"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "uploadinvoice",
      "name": "uploadinvoice",
      "value": "yes"
    },
    domProps: {
      "checked": _vm._q(_vm.uploadinvoice, "yes")
    },
    on: {
      "__c": function($event) {
        _vm.uploadinvoice = "yes"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enableinvoice"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.yes')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.uploadinvoice),
      expression: "uploadinvoice"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "uploadinvoice",
      "value": "no",
      "name": "uploadinvoice"
    },
    domProps: {
      "checked": _vm._q(_vm.uploadinvoice, "no")
    },
    on: {
      "__c": function($event) {
        _vm.uploadinvoice = "no"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "disableinvoice"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.no')))]), _vm._v(" "), (_vm.uploadinvoice == '') ? _c('span', {
    staticClass: "text-danger",
    model: {
      value: (_vm.uploadinvoiceError),
      callback: function($$v) {
        _vm.uploadinvoiceError = $$v
      },
      expression: "uploadinvoiceError"
    }
  }, [_vm._v(_vm._s(this.showpackingboxerror) + "\n                    ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-2"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.enableInvoice')) + " :")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', [_c('b-form-checkbox', {
    staticStyle: {
      "font-weight": "100",
      "margin-top": "15px"
    },
    attrs: {
      "name": "enableInvoice",
      "id": "enableInvoice"
    },
    model: {
      value: (_vm.enableInvoice),
      callback: function($$v) {
        _vm.enableInvoice = $$v
      },
      expression: "enableInvoice"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.uploadLogo')) + ":")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-picture-o'></i>"
    }
  }, [_c('input', {
    ref: "file",
    class: {
      'form-control': true
    },
    attrs: {
      "type": "file",
      "id": "file",
      "name": "file"
    },
    on: {
      "change": function($event) {
        _vm.onUploadImage()
      }
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "fileHelp"
    }
  }, [_vm._v(_vm._s(_vm.$t('config.maxUploadSize')) + ": 10 MB "), _c('br'), _vm._v("Allowed File Types: png, jpg, jpeg, gif, bmp")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.enableLabel')) + " :")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('b-input-group', [_c('b-form-checkbox', {
    staticStyle: {
      "font-weight": "100",
      "margin-top": "15px"
    },
    attrs: {
      "name": "enableLabel",
      "id": "enableLabel"
    },
    model: {
      value: (_vm.enableLabel),
      callback: function($$v) {
        _vm.enableLabel = $$v
      },
      expression: "enableLabel"
    }
  })], 1)], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.customerCarePhone')) + " :")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bookmark'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "maxlength": "12",
      "placeholder": _vm.$t('config.customerCarePlaceHolder'),
      "id": "ccphone"
    },
    on: {
      "keyup": function($event) {
        _vm.isNumber($event)
      }
    },
    model: {
      value: (_vm.ccphone),
      callback: function($$v) {
        _vm.ccphone = $$v
      },
      expression: "ccphone"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.ccphoneError))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.customerCareEmail')) + ":")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bookmark'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('config.customerCareEmailPlaceHolder'),
      "id": "ccemail"
    },
    on: {
      "keyup": _vm.validateEmail
    },
    model: {
      value: (_vm.ccemail),
      callback: function($$v) {
        _vm.ccemail = $$v
      },
      expression: "ccemail"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.ccemailError))])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('multiSellerPanel.customerAcknowledgement')) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8"
  }, [_c('ckeditor', {
    attrs: {
      "editor": _vm.editor,
      "config": _vm.editorConfig
    },
    model: {
      value: (_vm.custAcknowled),
      callback: function($$v) {
        _vm.custAcknowled = $$v
      },
      expression: "custAcknowled"
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.returnPolicies')) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8"
  }, [_c('ckeditor', {
    attrs: {
      "editor": _vm.editor,
      "config": _vm.editorConfig
    },
    model: {
      value: (_vm.returnPolicy),
      callback: function($$v) {
        _vm.returnPolicy = $$v
      },
      expression: "returnPolicy"
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.termsandConditions')) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8"
  }, [_c('ckeditor', {
    attrs: {
      "editor": _vm.editor,
      "config": _vm.editorConfig
    },
    model: {
      value: (_vm.tandc),
      callback: function($$v) {
        _vm.tandc = $$v
      },
      expression: "tandc"
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.RegisteredofficedAddress')) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8"
  }, [_c('ckeditor', {
    attrs: {
      "editor": _vm.editor,
      "config": _vm.editorConfig
    },
    model: {
      value: (_vm.officeAddress),
      callback: function($$v) {
        _vm.officeAddress = $$v
      },
      expression: "officeAddress"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-left": "135px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading,
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.saveInvoiceData()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.saveBtn')))])])])], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.client != "undefined" && _vm.client != '') ? _c('b-tab', {
    attrs: {
      "title": _vm.$t('config.marketPlace')
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row col-lg-12"
  }, [_c('b-card', {
    staticClass: "col-lg-12",
    staticStyle: {
      "line-height": "1.7"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.marketPlaceName')) + ": "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.marketplace),
      expression: "marketplace"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "enablerubicon",
      "name": "marketplacenaame",
      "value": "rubicon"
    },
    domProps: {
      "checked": _vm._q(_vm.marketplace, "rubicon")
    },
    on: {
      "__c": function($event) {
        _vm.marketplace = "rubicon"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enablerubicon"
    }
  }, [_vm._v(_vm._s(_vm.$t('config.rubicon')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.marketplace),
      expression: "marketplace"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "enableuniware",
      "name": "marketplacenaame",
      "value": "unicommerce"
    },
    domProps: {
      "checked": _vm._q(_vm.marketplace, "unicommerce")
    },
    on: {
      "__c": function($event) {
        _vm.marketplace = "unicommerce"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enableuniware"
    }
  }, [_vm._v(_vm._s(_vm.$t('config.unicommerce')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.marketplace),
      expression: "marketplace"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "enablemultiseller",
      "name": "marketplacenaame",
      "value": "multiseller"
    },
    domProps: {
      "checked": _vm._q(_vm.marketplace, "multiseller")
    },
    on: {
      "__c": function($event) {
        _vm.marketplace = "multiseller"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enablemultiseller"
    }
  }, [_vm._v(_vm._s(_vm.$t('config.multiseller')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.marketplace),
      expression: "marketplace"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "enableincreff",
      "name": "marketplacenaame",
      "value": "increff"
    },
    domProps: {
      "checked": _vm._q(_vm.marketplace, "increff")
    },
    on: {
      "__c": function($event) {
        _vm.marketplace = "increff"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enableincreff"
    }
  }, [_vm._v(_vm._s(_vm.$t('config.increff')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.marketplace),
      expression: "marketplace"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "nulluniware",
      "name": "marketplacenaame",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.marketplace, "0")
    },
    on: {
      "__c": function($event) {
        _vm.marketplace = "0"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "nulluniware"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('config.None')))])]), _vm._v(" "), (_vm.marketplaceError) ? _c('div', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.$t('config.selectAnOption')) + "\n                  ")]) : _vm._e()]), _vm._v(" "), (_vm.marketplace == 'unicommerce' || _vm.marketplace == 'increff') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.returnsIntegration')) + ": "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.returnsIntegration),
      expression: "returnsIntegration"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "enablereturnsIntegration",
      "name": "returnsIntegration",
      "value": "yes"
    },
    domProps: {
      "checked": _vm._q(_vm.returnsIntegration, "yes")
    },
    on: {
      "__c": function($event) {
        _vm.returnsIntegration = "yes"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enablereturnsIntegration"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.yes')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.returnsIntegration),
      expression: "returnsIntegration"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "disablereturnsIntegration",
      "name": "returnsIntegration",
      "value": "no"
    },
    domProps: {
      "checked": _vm._q(_vm.returnsIntegration, "no")
    },
    on: {
      "__c": function($event) {
        _vm.returnsIntegration = "no"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "disablereturnsIntegration"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.no')))])]), _vm._v(" "), (_vm.returnsIntegrationError) ? _c('div', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('editedjson.selectanoption')) + "\n                  ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.sellerPanelProcessing')) + ": "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderprocessing),
      expression: "orderprocessing"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "autoProcessing",
      "name": "orderprocessing",
      "value": "auto"
    },
    domProps: {
      "checked": _vm._q(_vm.orderprocessing, "auto")
    },
    on: {
      "__c": function($event) {
        _vm.orderprocessing = "auto"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "autoProcessing"
    }
  }, [_vm._v(_vm._s(_vm.$t('config.Auto')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderprocessing),
      expression: "orderprocessing"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "manualProcessing",
      "name": "orderprocessing",
      "value": "manual"
    },
    domProps: {
      "checked": _vm._q(_vm.orderprocessing, "manual")
    },
    on: {
      "__c": function($event) {
        _vm.orderprocessing = "manual"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "manualProcessing"
    }
  }, [_vm._v(_vm._s(_vm.$t('config.manual')))])]), _vm._v(" "), (_vm.orderprocessingError) ? _c('div', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.$t('config.selectAnOption')) + "\n                  ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.safetyStock')) + ": "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-money'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservestock),
      expression: "reservestock"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('reservestock')
    },
    attrs: {
      "type": "number",
      "step": "any",
      "placeholder": _vm.$t('config.reserverStockPlaceholder'),
      "min": "0",
      "max": "200",
      "name": "reservestock",
      "id": "reservestock"
    },
    domProps: {
      "value": (_vm.reservestock)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reservestock = $event.target.value
      }
    }
  })])], 1)], 1), _vm._v(" "), (_vm.reservestockError) ? _c('div', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.$t('config.EnterValuesError')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.smartRack')) + ": "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.smartrack),
      expression: "smartrack"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "smartrackenable",
      "name": "smartrack",
      "value": "yes"
    },
    domProps: {
      "checked": _vm._q(_vm.smartrack, "yes")
    },
    on: {
      "__c": function($event) {
        _vm.smartrack = "yes"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "smartrackenable"
    }
  }, [_vm._v(_vm._s(_vm.$t('config.enable')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.smartrack),
      expression: "smartrack"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "smartrackdisable",
      "name": "smartrack",
      "value": "no"
    },
    domProps: {
      "checked": _vm._q(_vm.smartrack, "no")
    },
    on: {
      "__c": function($event) {
        _vm.smartrack = "no"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "smartrackdisable"
    }
  }, [_vm._v(_vm._s(_vm.$t('config.disable')))])]), _vm._v(" "), (_vm.smartrackError) ? _c('div', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.$t('config.selectAnOption')) + "\n                  ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('common.multiSellerStatus')) + ": "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.multimerchant),
      expression: "multimerchant"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "multimerchantenable",
      "name": "multimerchant",
      "value": "yes"
    },
    domProps: {
      "checked": _vm._q(_vm.multimerchant, "yes")
    },
    on: {
      "__c": function($event) {
        _vm.multimerchant = "yes"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "multimerchantenable"
    }
  }, [_vm._v(_vm._s(_vm.$t('config.enable')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.multimerchant),
      expression: "multimerchant"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "multimerchantdisable",
      "name": "multimerchant",
      "value": "no"
    },
    domProps: {
      "checked": _vm._q(_vm.multimerchant, "no")
    },
    on: {
      "__c": function($event) {
        _vm.multimerchant = "no"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "multimerchantdisable"
    }
  }, [_vm._v(_vm._s(_vm.$t('config.disable')))])]), _vm._v(" "), (_vm.multimerchantError) ? _c('div', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.$t('config.selectAnOption')) + "\n                  ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(" " + _vm._s(_vm.$t('config.manifestLimit')) + ": "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cart-plus'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.manifestlimit),
      expression: "manifestlimit"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('manifestlimit')
    },
    attrs: {
      "type": "number",
      "step": "any",
      "placeholder": _vm.$t('config.manifestLimitPlaceHolder'),
      "min": "1",
      "max": "2000",
      "name": "manifestlimit",
      "id": "manifestlimit"
    },
    domProps: {
      "value": (_vm.manifestlimit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.manifestlimit = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), (_vm.manifestError) ? _c('div', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.$t('config.manifestLimitError')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-left": "135px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading,
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.saveMarketPlace()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.saveBtn')))])])])])], 1)], 1), _vm._v(" "), ((_vm.warehouse != "undefined" && _vm.warehouse != '') && (_vm.client != "undefined" && _vm.client != '')) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row col-lg-12"
  }, [_c('b-card', {
    staticClass: "col-lg-12",
    staticStyle: {
      "line-height": "1.7"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('config.rackPrefix')) + ": ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-money'></i>"
    }
  }, [(_vm.hasPrefix == true) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rackprefix),
      expression: "rackprefix"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('rackprefix')
    },
    attrs: {
      "readonly": "",
      "type": "text",
      "placeholder": _vm.$t('config.rackPrefixPlaceHolder'),
      "name": "rackprefix",
      "id": "rackprefix"
    },
    domProps: {
      "value": (_vm.rackprefix)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rackprefix = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasPrefix == false) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rackprefixtemp),
      expression: "rackprefixtemp"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('rackprefix')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('config.rackPrefixPlaceHolder'),
      "name": "rackprefix",
      "id": "rackprefix"
    },
    domProps: {
      "value": (_vm.rackprefixtemp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rackprefixtemp = $event.target.value
      }
    }
  }) : _vm._e()])], 1)], 1), _vm._v(" "), (_vm.rackprefixError) ? _c('div', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.rackError))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-left": "135px"
    }
  }, [(_vm.hasPrefix == false) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading,
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.saveRackPrefix()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.saveBtn')))]) : _vm._e()])])])], 1)], 1) : _vm._e(), _vm._v(" "), ((_vm.warehouse != "undefined" && _vm.warehouse != '') && (_vm.client != "undefined" && _vm.client != '')) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row col-lg-12"
  }, [_c('b-card', {
    staticClass: "col-lg-12",
    staticStyle: {
      "line-height": "1.7"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(" Is Spoc: "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enablespoc),
      expression: "enablespoc"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "enablespoc",
      "name": "enablespoc",
      "value": "yes"
    },
    domProps: {
      "checked": _vm._q(_vm.enablespoc, "yes")
    },
    on: {
      "__c": function($event) {
        _vm.enablespoc = "yes"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enablespoc"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.yes')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enablespoc),
      expression: "enablespoc"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "disablespoc",
      "name": "enablespoc",
      "value": "no"
    },
    domProps: {
      "checked": _vm._q(_vm.enablespoc, "no")
    },
    on: {
      "__c": function($event) {
        _vm.enablespoc = "no"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enablespoc"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.no')))]), _vm._v(" "), (_vm.enablespocerror) ? _c('div', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.$t('config.manifestLimitError')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-left": "135px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading,
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.saveSpoc()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.saveBtn')))])])])])], 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.client != "undefined" && _vm.client != '') ? _c('b-tab', {
    attrs: {
      "title": _vm.$t('config.fcWh')
    }
  }, [((_vm.warehouse != "undefined" && _vm.warehouse != '') && (_vm.client != "undefined" && _vm.client != '')) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row col-lg-12"
  }, [_c('b-card', {
    staticClass: "col-lg-12",
    staticStyle: {
      "line-height": "1.7"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(" " + _vm._s(_vm.$t('config.fcEnabled')) + ": "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fcwarehouse),
      expression: "fcwarehouse"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "enablefcwarehouse",
      "name": "enablefcwarehousename",
      "value": "yes"
    },
    domProps: {
      "checked": _vm._q(_vm.fcwarehouse, "yes")
    },
    on: {
      "__c": function($event) {
        _vm.fcwarehouse = "yes"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enablerubicon"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.yes')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fcwarehouse),
      expression: "fcwarehouse"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "disablefcwarehouse",
      "name": "enablefcwarehousename",
      "value": "no"
    },
    domProps: {
      "checked": _vm._q(_vm.fcwarehouse, "no")
    },
    on: {
      "__c": function($event) {
        _vm.fcwarehouse = "no"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enableuniware"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.no')))])]), _vm._v(" "), (_vm.fcwarehouseError) ? _c('div', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.$t('config.selectAnOption')) + "\n                  ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('editedjson.routingEnabled')) + ": "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.routingenabled),
      expression: "routingenabled"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "enablerouting",
      "name": "enableroutingname",
      "value": "yes"
    },
    domProps: {
      "checked": _vm._q(_vm.routingenabled, "yes")
    },
    on: {
      "__c": function($event) {
        _vm.routingenabled = "yes"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enablerubicon"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.yes')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.routingenabled),
      expression: "routingenabled"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "disablerouting",
      "name": "enableroutingname",
      "value": "no"
    },
    domProps: {
      "checked": _vm._q(_vm.routingenabled, "no")
    },
    on: {
      "__c": function($event) {
        _vm.routingenabled = "no"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enableuniware"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.no')))])]), _vm._v(" "), (_vm.routingEnabledError) ? _c('div', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.$t('editedjson.selectanoption')) + "\n                  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-left": "135px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading,
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.saveFcWarehouse()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.saveBtn')))])])])])], 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.client != "undefined" && _vm.client != '') ? _c('b-tab', {
    attrs: {
      "title": _vm.$t('config.crossdock')
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row col-lg-12"
  }, [_c('b-card', {
    staticClass: "col-lg-12",
    staticStyle: {
      "line-height": "1.7"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('label', [_c('strong', [_vm._v("Enable Planned Cross Dock :")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.crossdock),
      expression: "crossdock"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "enablecrossdock",
      "name": "crossdock",
      "value": "yes"
    },
    domProps: {
      "checked": _vm._q(_vm.crossdock, "yes")
    },
    on: {
      "click": _vm.changeEnableCrossdock,
      "__c": function($event) {
        _vm.crossdock = "yes"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enablecrossdock"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.yes')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.crossdock),
      expression: "crossdock"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "disablecrossdock",
      "name": "crossdock",
      "value": "no"
    },
    domProps: {
      "checked": _vm._q(_vm.crossdock, "no")
    },
    on: {
      "click": _vm.changeEnableCrossdock,
      "__c": function($event) {
        _vm.crossdock = "no"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "disablecrossdock"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.no')))]), _vm._v(" "), (_vm.crossdock == '') ? _c('span', {
    staticClass: "text-danger",
    model: {
      value: (_vm.crossdockerror),
      callback: function($$v) {
        _vm.crossdockerror = $$v
      },
      expression: "crossdockerror"
    }
  }, [_vm._v(_vm._s(this.crossdockerror) + "\n                      ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "border_dark"
  }, [_c('div', {
    staticClass: "color_blue",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.productCategory')))])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "0px 5px 10px 5px"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "searchprodcat",
      "placeholder": _vm.$t('inwardList.search')
    },
    model: {
      value: (_vm.searchprodcat),
      callback: function($$v) {
        _vm.searchprodcat = $$v
      },
      expression: "searchprodcat"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("\n                                  " + _vm._s(_vm.$t('config.totalSelected')) + " " + _vm._s(_vm.pcount) + "\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "button",
      "id": "prodcat"
    },
    on: {
      "click": function($event) {
        _vm.selectAllProductCat()
      }
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t('removeHold.selectAll')) + "\n                                    ")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "20vh",
      "width": "100%",
      "overflow": "scroll"
    }
  }, _vm._l((_vm.resultproductCategory), function(item, index) {
    return _c('div', {
      staticClass: "form-group",
      class: {
        'disabled-div': _vm.disableSelection
      },
      staticStyle: {
        "display": "inline-flex"
      }
    }, [_c('div', {
      class: {
        selected: item.isselected,
        notselected: !item.isselected
      },
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.selectCategory(item, index)
        }
      }
    }, [_c('div', [_c('span', {
      attrs: {
        "id": "prodcat"
      }
    }, [_vm._v("  " + _vm._s(item.productcategory))])])])])
  }))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "border_dark"
  }, [_c('div', {
    staticClass: "color_blue",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.salesChannel')))])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "0px 5px 10px 5px"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "searchsaleschannel",
      "placeholder": _vm.$t('inwardList.search')
    },
    model: {
      value: (_vm.searchsaleschannel),
      callback: function($$v) {
        _vm.searchsaleschannel = $$v
      },
      expression: "searchsaleschannel"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("\n                                  " + _vm._s(_vm.$t('config.totalSelected')) + " " + _vm._s(_vm.scount) + "\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "button",
      "id": "channel"
    },
    on: {
      "click": function($event) {
        _vm.selectAllChannel()
      }
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t('removeHold.selectAll')) + "\n                                    ")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "20vh",
      "width": "100%",
      "overflow": "scroll"
    }
  }, _vm._l((_vm.resultsalesChannel), function(item, index) {
    return _c('div', {
      staticClass: "form-group",
      class: {
        'disabled-div': _vm.disableSelection
      },
      staticStyle: {
        "display": "inline-flex"
      }
    }, [_c('div', {
      class: {
        selected: item.isselected,
        notselected: !item.isselected
      },
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.selectChannel(item, index)
        }
      }
    }, [_c('div', [_c('span', [_vm._v("  " + _vm._s(item.saleschannel))])])])])
  }))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-left": "45px",
      "margin-top": "45px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "id": "submitcrossdock",
      "disabled": _vm.isLoading,
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.crossDock()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.saveBtn')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset",
      "size": "sm"
    },
    on: {
      "click": _vm.resetCrossDock
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.$t('common.resetBtn')))])])])], 1)], 1)]) : _vm._e()], 1) : _vm._e()], 1)])])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-070e4721", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-070e4721","hasScoped":true}!./src/views/components/config/config.component.html
// module id = 1567
// module chunks = 0